export function dataInRequest(params = {}) {
  return {
    type: '@operacaoLubrificacao/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@operacaoLubrificacao/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoLubrificacao/FAILED_REQUEST',
  };
}

export function deleteData(id, params, query = {}) {
  return {
    type: '@operacaoLubrificacao/DELETE_DATA',
    payload: { id, params, query },
  };
}

export function updateData(data, params) {
  return {
    type: '@operacaoLubrificacao/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@operacaoLubrificacao/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoLubrificacao/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoLubrificacao/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoLubrificacao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function successRemoveForm(params) {
  return {
    type: '@operacaoLubrificacao/SUCCESS_REMOVE_FORM',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoLubrificacao/RECORD_FILTERING',
    payload: { params },
  };
}

export function deletarClienteOperacaoLubrificacao(data, params) {
  return {
    type: '@operacaoLubrificacao/DELETE_OPERACAOLUBRIFICACAO_CLIENTE',
    payload: { data, params },
  };
}
